"use client";
import Image from "next/image";
import { Heading } from "@/components/ui/typography";

const features = [
  {
    icon: "/how-it-work/book-shelf-line0.svg",
    label: "Monthly Bookkeeping",
    title:
      "monthly bookkeeping coordination keeps your structure clean year-round",
  },
  {
    icon: "/how-it-work/game-icons-book-pile0.svg",
    label: "Annual Filing Reminders",
    title:
      "annual filing reminders and Business Registration renewals handled proactively",
  },
  {
    icon: "/how-it-work/group0.svg",
    label: "Annual Return Submissions",
    title:
      "Annual Return submissions and Profits Tax Return coordination managed for you",
  },
  {
    icon: "/how-it-work/streamline-cyber-color-map-target-20.svg",
    label: "Offshore Positioning",
    title:
      "offshore eligibility positioning support throughout your company's lifecycle",
  },
  {
    icon: "/how-it-work/ic-baseline-whatsapp0.svg",
    label: "WhatsApp Account Manager",
    title:
      "WhatsApp account manager access you're not left managing compliance alone after incorporation finishes",
  },
];

export default function SupportSection({ heading = "Life After Setup, Ongoing Support Continues" }: { heading?: string } = {}) {
  return (
    <section className="w-full bg-black py-[60px] min-[1340px]:px-0 px-4">

      {/* HEADER */}
      <div className="max-w-[782px] mx-auto text-center px-4 flex flex-col gap-6">
        <Heading as="h2" variant="sectionCentered" className="w-[80%] mx-auto">
          {heading}
        </Heading>

        <p className="text-white/70 text-[16px] leading-6">
          Formation is only the beginning. After onboarding completes, your
          structure stays supported.
        </p>
      </div>

      {/* CARDS */}
      <div className="max-w-[1200px] mx-auto mt-[50px] grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-5 md:gap-6 gap-4">

        {features.map((item, i) => (
          <div
            key={i}
            className="border border-white/10 rounded-xl md:p-6 p-4 flex flex-col gap-6 h-full"
          >
            <Image
              src={item.icon}
              alt={item.label}
              width={48}
              height={48}
              className="[filter:brightness(0)_invert(1)]"
            />

            <div className="flex flex-col gap-2">
              <p className="text-[12px] text-white/60">
                {item.label}
              </p>

              <p className="text-[16px] lg:text-[18px] leading-[120%] font-medium text-white">
                {item.title}
              </p>
            </div>
          </div>
        ))}

      </div>

      {/* FOOTER TEXT */}
      <p className="max-w-[780px] mx-auto text-center text-white/70 text-[16px] leading-6 mt-[32px] px-4">
        You can review full compliance support on the HK Company Pricing page and
        offshore positioning guidance on the Tax Optimization page.
      </p>

    </section>
  );
}